<style>
.el-table__body tr.current-row>td{
  background-color: #ECF5FF !important;
}

.el-table .cell{
  word-break: break-word !important;
  white-space: pre-line !important
}

</style>
<template>
  <el-row type="flex" class="row-bg" justify="center">
    <el-col :xs="24" :sm="24" :md="24" :lg="20" :xl="18" >
      <div id="app" style="font-family:'Segoe UI'">
        <navbar></navbar>
        <RouterView :key="$route.fullPath" style="border: 1px solid #13305D"></RouterView>
      </div>
    </el-col>
  </el-row>
</template>

<script>
  import navbar from "@/components/navbar/navbar";



  export default {
    name:'App',
    mounted() {
      const script = document.createElement('script')
      script.src = 'https://s4.cnzz.com/z_stat.php?id=1280064124&web_id=1280064124'
      script.language = 'JavaScript'
      document.body.appendChild(script)
    },
    components:{
      navbar
    },

    watch: {
      '$route' () {
        if (window._czc) {
          let location = window.location
          let contentUrl = location.pathname + location.hash
          let refererUrl = '/'
          window._czc.push(['_trackPageview', contentUrl, refererUrl])
        }
      }
    }
  }
</script>
<style>
@import "./assets/css/base.css";
@import "~element-ui/lib/theme-chalk/display.css";


</style>
